import React from 'react';
import { arrayOf, func, node, number, shape, string } from 'prop-types';
import classNames from 'classnames';

import css from './SegmentedControl.module.css';

/**
 * The segmented control from the Components board ("List · Map", "Upcoming · Past · Saved"): one
 * choice out of a few, shown side by side. Each segment is a toggle button (`aria-pressed`) in a
 * labelled group. An option can carry a `count`, shown after its label.
 */
const SegmentedControl = props => {
  const { rootClassName, className, ariaLabel, options, value, onChange } = props;
  return (
    <div
      className={classNames(rootClassName || css.root, className)}
      role="group"
      aria-label={ariaLabel || undefined}
    >
      {options.map(option => {
        const isOn = option.key === value;
        return (
          <button
            key={option.key}
            type="button"
            className={classNames(css.segment, { [css.segmentOn]: isOn })}
            aria-pressed={isOn}
            onClick={() => (isOn ? null : onChange(option.key))}
          >
            {option.label}
            {typeof option.count === 'number' ? (
              <span className={css.count}>{option.count}</span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
};

SegmentedControl.defaultProps = { rootClassName: null, className: null, ariaLabel: null };

SegmentedControl.propTypes = {
  rootClassName: string,
  className: string,
  // Names the group for screen readers when nothing visible does, e.g. "View"
  ariaLabel: string,
  options: arrayOf(shape({ key: string.isRequired, label: node.isRequired, count: number }))
    .isRequired,
  value: string.isRequired,
  onChange: func.isRequired,
};

export default SegmentedControl;
